module.exports = __webpack_public_path__ + "bg_panflet_papa.13e5aadf.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/parent_to_child/bg_panflet_papa.png
// module id = l/bB
// module chunks = 0